import React from 'react'
import { AlarmIcon } from '../../../assets/icons/alarm';
import { Button, SidebarDrawer } from '../../common'
const subscriptionExpiry = () => {
  return (
    <div className='flex flex-col'>
    <div className='flex justify-center pb-[60px]'>
     <AlarmIcon/>
    </div>
    <div className='px-[24px]'>
      <div className='mb-[40px] flex flex-col gap-[16px]'>
      <h1 className='text-[24px]' style={{fontWeight: 600}}>Oh oh ! Subscription Expired </h1>
      <p>Your request cannot be completed becuase your subscription has expired. Kindly renew your subscription to enjoy this feature.</p> 
   </div>
   <div>
   <Button variant='danger'>Subscribe Now</Button> 
   </div>
   </div> 
   </div>
  )
}

export default subscriptionExpiry